const NotFoundPage = () => (
  <div style={{ textAlign: "center", marginTop: "10vh" }}>
    <h1 style={{ fontSize: "3rem", color: "#ef4444" }}>404</h1>
    <h2>Welcome to Who's in?</h2>
    <p>
      Unfortuntely, The page you are looking for does not exist. If you think
      this is an error, please contact contact@whoisin.sg
    </p>
    <a href="/" style={{ color: "#3b82f6", textDecoration: "underline" }}>
      Go to Home
    </a>
  </div>
);

export default NotFoundPage;
